import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './Doc.module.css';
import { patientActions } from '_actions'
import { getDateMDYYYY } from '_helpers'
import { TherapistDashboardOutstandingNotes } from 'TherapistDashboard';
class PatientHomeCdvLimberDoc extends React.Component {


    openLimber() {
        this.props.openLimberPdf(this.props.limberDoc.epno, this.props.limberDoc.assessmentId, this.props.limberDoc.assessmentId, this.props.ptno);
    }



    render() {
        return (
            <div>
                <div className={styles.doc_wrapper} onClick={() => this.openLimber()} id={this.props.limberDoc.assessmentId} key={this.props.limberDoc.assessmentId}>
                    <div className={styles.doc_row}>
                        <div className={styles.icon}>
                            <img alt='Limber' className={styles.limber_badge} src='./images/limber.png' title="Limber" onClick={() => this.openLimberPdf()}></img>
                        </div>
                        <div className={styles.icon} />
                        <div className={styles.icon} />
                        <div className={styles.iconSpace} />

                        <div className={styles.supervisior_icon} />
                        <div className={styles.doc_name}>
                            {this.props.limberDoc.assessmentDisplayName}
                        </div>
                        <div className={styles.doc_dos}>
                            <span className={styles.inline_header}>DOS:</span>{this.props.limberDoc.completedDate ? getDateMDYYYY(this.props.limberDoc.completedDate) : ''}
                        </div>
                        <div className={styles.doc_visit} />
                        <div className={styles.doc_therapist} />
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openLimberPdf: bindActionCreators(patientActions.openLimberPdf, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let epno = state.entities.limberAssessments[ownprops.id].epno;
    let ptno = state.entities.admissions[epno].ptno;
    return {
        ptno,
        limberDoc: state.entities.limberAssessments[ownprops.id]
    };
}

const connectedPatientHomeCdvLimberDoc = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvLimberDoc);
export { connectedPatientHomeCdvLimberDoc as PatientHomeCdvLimberDoc };

